export default __webpack_public_path__ + "static/media/2-logos_low-code.f6fb36cd.png";